import { render, staticRenderFns } from "./ImportRecords.vue?vue&type=template&id=1a9331c8"
import script from "./ImportRecords.vue?vue&type=script&lang=js"
export * from "./ImportRecords.vue?vue&type=script&lang=js"
import style0 from "./ImportRecords.vue?vue&type=style&index=0&id=1a9331c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports